import { Injectable } from '@angular/core';
import { PaymentSettings } from '../settings/payment.settings';
import { HttpResponse } from '@angular/common/http';
import { HttpCssClient } from '../shared/http-request.interceptor'
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class PaymentService{
    constructor(private http:HttpCssClient){}
    getCountries():Observable<Object>{
        let url = PaymentSettings.GET_COUNTRIES;
        return this.http.get(url).pipe(map(function(response:HttpResponse<any>){
            return response;
        }));
    }

    confirmPayment(paymentData):Observable<Object>{
        let url = PaymentSettings.CONFIRM_PAYMENT;
        return this.http.post(url,paymentData).pipe(map(function(response:HttpResponse<any>){
            return response.body;
        })).pipe(catchError(function(e:Response):Observable<Object>{
            if(e.status == 500)
            return throwError('Exception ocurred');
        }));
    }

    getLocalPaymentMethods(data):Observable<Object[]>{
        let url = PaymentSettings.PAYMENT_METHODS;
        return this.http.post(url,data).pipe(map(function(response:HttpResponse<any>){
            return response.body;
        })).pipe(catchError(function(e:HttpResponse<any>):Observable<Object>{
            if(e.status == 500)
            return throwError('Exception ocurred');
            if(e.status == 404) //No local payments.            
            return e.body;
        }));
    }

    localPayment(multiPaymentData):Observable<Object>{
        let url = PaymentSettings.CONFIRM_LOCAL_PAYMENT;
        return this.http.post(url,multiPaymentData).pipe(map(function(response:HttpResponse<any>){
            return response.body;
        })).pipe(catchError(function(e:HttpResponse<any>):Observable<Object>{
            if(e.status == 500)
            return throwError('Exception ocurred');
        }));
    }
}